import { createContext } from 'react';
import { initialState } from './Toast.constants';
import { tToastContext } from './Toast.types';

export const ToastContext = createContext<tToastContext>(initialState);
